import { apiErrorToToast } from "@/lib/utils";
import { createCompany } from "@/requests/companies/create-company.request";
import { ApiErrorResponse } from "@/types/apis";
import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

export const useCreateCompany = () => {
  return useMutation({
    mutationFn: createCompany,
    onError: (error: AxiosError<ApiErrorResponse>) => {
      apiErrorToToast(error);
    },
  });
};
